{
  "AGENT_BOTS": {
    "HEADER": "בוטים",
    "LOADING_EDITOR": "טוען עורך...",
    "DESCRIPTION": "בוטים של סוכנים הם כמו החברים הכי נפלאים בצוות שלכם. הם יכולים להתמודד עם הדברים הקטנים, כך שאתם יכולים להתמקד בדברים החשובים. נסו אותם. אתם יכולים לנהל את הבוטים שלכם מדף זה או ליצור חדשים באמצעות כפתור 'הוסף בוט'.",
    "LEARN_MORE": "למד על בוטי סוכנים",
    "COUNT": "{n} bot | {n} bots",
    "SEARCH_PLACEHOLDER": "Search bots...",
    "NO_RESULTS": "No bots found matching your search",
    "GLOBAL_BOT": "בוט מערכת",
    "GLOBAL_BOT_BADGE": "מערכת",
    "AVATAR": {
      "SUCCESS_DELETE": "אווטר הבוט נמחק בהצלחה",
      "ERROR_DELETE": "שגיאה במחיקת אווטר הבוט, אנא נסה שוב"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "בחר בוט סוכן",
      "DESC": "הקצה בוט סוכן לתיבת הדואר הנכנס שלך. הם יכולים לטפל בשיחות ראשוניות ולהעביר אותן לסוכן חי כאשר נדרש.",
      "SUBMIT": "עדכן",
      "DISCONNECT": "נתק בוט",
      "SUCCESS_MESSAGE": "בוט הסוכן עודכן בהצלחה.",
      "DISCONNECTED_SUCCESS_MESSAGE": "בוט הסוכן נותק בהצלחה.",
      "ERROR_MESSAGE": "לא ניתן לעדכן את בוט הסוכן. אנא נסה שוב.",
      "DISCONNECTED_ERROR_MESSAGE": "לא ניתן לנתק את בוט הסוכן. אנא נסה שוב.",
      "SELECT_PLACEHOLDER": "בחר בוט"
    },
    "ADD": {
      "TITLE": "הוסף בוט",
      "CANCEL_BUTTON_TEXT": "ביטול",
      "API": {
        "SUCCESS_MESSAGE": "הבוט התווסף בהצלחה.",
        "ERROR_MESSAGE": "לא ניתן להוסיף בוט. אנא נסה שוב מאוחר יותר."
      }
    },
    "LIST": {
      "404": "לא נמצאו בוטים. אתה יכול ליצור בוט על ידי לחיצה על כפתור 'הוסף בוט'.",
      "LOADING": "טוען בוטים...",
      "TABLE_HEADER": {
        "DETAILS": "פרטי בוט",
        "URL": "כתובת URL של ווב הוק",
        "ACTIONS": "פעולות"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "מחק",
      "TITLE": "מחק בוט",
      "CONFIRM": {
        "TITLE": "אשר מחיקה",
        "MESSAGE": "האם אתה בטוח שברצונך למחוק את {name}?",
        "YES": "כן, מחק",
        "NO": "לא, השאר"
      },
      "API": {
        "SUCCESS_MESSAGE": "הבוט נמחק בהצלחה.",
        "ERROR_MESSAGE": "לא ניתן למחוק בוט. אנא נסה שוב."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "ערוך",
      "TITLE": "ערוך בוט",
      "API": {
        "SUCCESS_MESSAGE": "הבוט עודכן בהצלחה.",
        "ERROR_MESSAGE": "לא ניתן לעדכן בוט. אנא נסה שוב."
      }
    },
    "SECRET": {
      "LABEL": "Webhook Secret",
      "COPY": "Copy secret to clipboard",
      "COPY_SUCCESS": "Secret copied to clipboard",
      "TOGGLE": "Toggle secret visibility",
      "CREATED_DESC": "Use the secret below to verify webhook signatures. Please copy it now, you can also find it later in the bot settings.",
      "DONE": "Done",
      "RESET_SUCCESS": "Webhook secret regenerated successfully",
      "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
    },
    "ACCESS_TOKEN": {
      "TITLE": "אסימון גישה",
      "DESCRIPTION": "העתק את אסימון הגישה ושמור אותו בבטחה",
      "COPY_SUCCESSFUL": "אסימון הגישה הועתק ללוח",
      "RESET_SUCCESS": "אסימון הגישה חודש בהצלחה",
      "RESET_ERROR": "לא ניתן לחדש את אסימון הגישה. אנא נסה שוב"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "אווטר בוט"
      },
      "NAME": {
        "LABEL": "שם בוט",
        "PLACEHOLDER": "הכנס שם בוט",
        "REQUIRED": "שם בוט נדרש"
      },
      "DESCRIPTION": {
        "LABEL": "תיאור",
        "PLACEHOLDER": "מה הבוט הזה עושה?"
      },
      "WEBHOOK_URL": {
        "LABEL": "כתובת URL של ווב הוק",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "כתובת URL של ווב הוק נדרשת"
      },
      "ERRORS": {
        "NAME": "שם בוט נדרש",
        "URL": "כתובת URL של ווב הוק נדרשת",
        "VALID_URL": "אנא הכנס כתובת URL תקינה המתחילה ב-http:// או https://"
      },
      "CANCEL": "ביטול",
      "CREATE": "צור בוט",
      "UPDATE": "עדכן בוט"
    },
    "WEBHOOK": {
      "DESCRIPTION": "הגדר בוט ווב הוק כדי לשלב עם השירותים המותאמים אישית שלך. הבוט יקבל ויעבד אירועים משיחות ויכול להגיב עליהם."
    },
    "TYPES": {
      "WEBHOOK": "בוט ווב הוק"
    }
  }
}
